var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.285 0.571289H3.71359V3.42843H12.285V0.571289ZM12.9993 6.99986C12.8099 6.99986 12.6282 6.9246 12.4942 6.79065C12.3603 6.6567 12.285 6.47501 12.285 6.28557C12.285 6.09613 12.3603 5.91445 12.4942 5.7805C12.6282 5.64654 12.8099 5.57129 12.9993 5.57129C13.1887 5.57129 13.3704 5.64654 13.5044 5.7805C13.6383 5.91445 13.7136 6.09613 13.7136 6.28557C13.7136 6.47501 13.6383 6.6567 13.5044 6.79065C13.3704 6.9246 13.1887 6.99986 12.9993 6.99986ZM10.8564 11.9999H5.14216V8.42843H10.8564V11.9999ZM12.9993 4.14272H2.9993C2.43098 4.14272 1.88594 4.36848 1.48407 4.77035C1.08221 5.17221 0.856445 5.71725 0.856445 6.28557V10.5713H3.71359V13.4284H12.285V10.5713H15.1422V6.28557C15.1422 5.71725 14.9164 5.17221 14.5145 4.77035C14.1127 4.36848 13.5676 4.14272 12.9993 4.14272Z",
    fill: "#78909C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.3218bda7d1733948b26f6c03a0aea255.svg";
export { ForwardRef as ReactComponent };